module.exports = __webpack_public_path__ + "img/brands-barilla-rotini.png?53af3dc036a89a634434752123a74416";